import { render } from "./ViewPersonnel.vue?vue&type=template&id=0b500668&scoped=true&ts=true"
import script from "./ViewPersonnel.vue?vue&type=script&lang=ts"
export * from "./ViewPersonnel.vue?vue&type=script&lang=ts"

import "./ViewPersonnel.vue?vue&type=style&index=0&id=0b500668&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b500668"]])

export default __exports__